"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var BlockStyleStore_1 = __importDefault(require("./BlockStyleStore"));
var Animator_1 = __importDefault(require("./Animator"));
var BlockStore = (function () {
    function BlockStore(angularBlockModel, $timeout) {
        var _this = this;
        this.angularBlockModel = angularBlockModel;
        this.wasUpdatedFromAngular = false;
        this._id = angularBlockModel._id;
        this.$id = angularBlockModel.$id;
        this.blockType = angularBlockModel.type;
        this.blockStyleStore = new BlockStyleStore_1.default();
        this.animator = new Animator_1.default(angularBlockModel, this._id, this.blockStyleStore, $timeout);
        this.turnOffAnimation = this.animator.turnOffAnimation;
        this.previewAnimation = this.animator.previewAnimation;
        this.cssBlockName = angularBlockModel.cssBlockName;
        this.contentAreas = angularBlockModel.contentAreas;
        this.updateFromAngular();
        (0, mobx_1.reaction)(function () {
            return { style: __assign({}, _this.blockStyleStore.model) };
        }, function (data) {
            _this.updateAngularModel(data);
        }, {
            fireImmediately: true,
        });
    }
    Object.defineProperty(BlockStore.prototype, "proxyBlockModel", {
        get: function () {
            var model = {
                type: this.blockType,
                style: this.blockStyleStore.model,
            };
            if (this._id) {
                model._id = this._id;
            }
            if (this.$id) {
                model.$id = this.$id;
            }
            if (this.contentAreas) {
                model.contentAreas = this.contentAreas;
            }
            return model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlockStore.prototype, "rawBlockModel", {
        get: function () {
            return this.angularBlockModel;
        },
        enumerable: false,
        configurable: true
    });
    BlockStore.prototype.updateFromAngular = function () {
        var styleChanged = this.blockStyleStore.updateFromAngular(this.angularBlockModel.style);
        if (styleChanged) {
            this.wasUpdatedFromAngular = true;
        }
    };
    Object.defineProperty(BlockStore.prototype, "blockId", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlockStore.prototype, "isSavedBlock", {
        get: function () {
            return !!this.rawBlockModel.$isSavedBlock;
        },
        enumerable: false,
        configurable: true
    });
    BlockStore.prototype.updateAngularModel = function (newData) {
        var e_1, _a;
        if (!this.wasUpdatedFromAngular) {
            try {
                for (var _b = __values(Object.keys(newData)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    if (this.angularBlockModel[key] && newData[key]) {
                        if (typeof this.angularBlockModel[key] === "object") {
                            Object.assign(this.angularBlockModel[key], newData[key]);
                        }
                        else {
                            this.angularBlockModel[key] = newData[key];
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else {
            this.wasUpdatedFromAngular = false;
        }
    };
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], BlockStore.prototype, "contentAreas", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BlockStore.prototype, "proxyBlockModel", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BlockStore.prototype, "rawBlockModel", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BlockStore.prototype, "updateFromAngular", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BlockStore.prototype, "blockId", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BlockStore.prototype, "isSavedBlock", null);
    return BlockStore;
}());
exports.default = BlockStore;
